import { faBan, faCheck, faCrosshairs, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { startDeleteRegister } from "@redux/actions/list"
import { AbilityContext } from '@src/utility/context/Can'
import { useContext, useState } from "react"
import { useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import Badge from "reactstrap/lib/Badge"
import DropdownItem from "reactstrap/lib/DropdownItem"
import { editCollectionRegister, handleChangeController, handleCleanForm, handleStartEditing } from "../../redux/actions/form"
import { serverRequest } from "../../utility/helpers/Axios/serverRequest"
import { getDateTime } from "../../utility/helpers/DateTime/formatDate"
import { handleSwitchConfirmation } from "../../utility/helpers/handleSwitchConfirmation"
import { productStatus } from '../enumsConf/productStatus'
import './styles/styles.css'
import { handleChange } from '../../redux/actions/list'
import ReactSelect from 'react-select'
import { handleGenericSwal } from '../../utility/helpers/Swal/handleGenericSwal'

export const statusActiveOptions = { true: { c: 'light-success', v: 'Activo' }, false: { c: 'light-danger', v: 'Inactivo' } }
export const statusViewedOptions = { true: { c: 'light-primary', v: 'Visto' }, false: { c: 'light-secondary', v: 'No visto' } }
export const statusOpenOptions = { true: { c: 'light-primary', v: 'Abierta' }, false: { c: 'light-success', v: 'Cerrada' } }

export const badgeDinamicState = (r, e, o, st = 'status') => {
    const [s, setS] = useState(r[st])
    return <Badge onClick={async () => {
        if (await handleSwitchConfirmation()) {
            await serverRequest(e, r.id, { ...r, [st]: !r[st] }, "PUT")
            setS(!s)
        }
    }} className='w-100 cursor-pointer' color={o[s]?.c}>{o[s]?.v}</Badge>
}

export const saleProductStatusConf = (status) => {
    const conf = productStatus[status]
    if (conf) return conf
    return {}
}

export const SalePruductStatus = (status, onClick = () => { }) => {
    const { className } = saleProductStatusConf(status)
    return <Badge onClick={() => onClick()} className={className}>Revisando</Badge>;
}

const linkAction = (r, n, p, l, t) => {
    const dispatch = useDispatch()
    const a = useContext(AbilityContext)
    const realPath = t ? `${p}/edit/${r.id}` : `${p}/${r.id}`
    return <>
        {a.can('update', n) ? (<Link to={realPath} onClick={() => { dispatch(handleCleanForm()) }}>{r[l]}</Link>) : r[l]}
    </>
}

const basicActions = (r, n, p, d, i, e, t) => {
    const dispatch = useDispatch()
    const a = useContext(AbilityContext)
    const realPath = t ? `/${p}/edit/${r.id}` : `/${p}/${r.id}`
    return <>
        {a.can('update', n) && (
            <Link to={realPath} onClick={() => { dispatch(handleCleanForm()) }}>
                <span className="dropdown-item"><FontAwesomeIcon icon={faEdit} /></span>
            </Link>)
        }
        {(a.can('delete', n) && d && !r.unDelete) && (
            <Link to={`#`} onClick={() => {
                dispatch(startDeleteRegister(r.id, e)).then(() => {
                    if (e) dispatch(handleStartEditing(n, r.id))
                })
            }}>
                <span className="dropdown-item"><FontAwesomeIcon icon={faTrash} /></span>
            </Link>)
        }
        {(a.can('actions', n) && i) && (
            <Link to={`/incidences/add/${p}/${r.id}`}>
                <span className="dropdown-item"><FontAwesomeIcon icon={faTriangleExclamation} /></span>
            </Link>)
        }
    </>
}

export const SelectStatus = (row, index, options, endPoint, isList = true, collection = []) => {
    const dispatch = useDispatch()
    const { id, status } = row
    const reactSelectStyles = {
        control: (baseStyles) => ({ ...baseStyles, padding: '0px', minHeight: '1.1rem !important', border: 'none' }),
        singleValue: (baseStyles) => ({ ...baseStyles, width: '100%', maxWidth: '100%', margin: '0px' }),
        valueContainer: (baseStyles) => ({ ...baseStyles, height: '1.4rem', padding: '0px' })
    }

    const handleOnChange = async (e) => {
        const { confirm } = await handleGenericSwal({
            title: '¿Estás seguro que quieres cambiar el estado del registro?',
            text: ' ',
            configuration: { confirmButtonText: 'Confirmar' },
            confirm: {
                title: '¡Aplicando cambios!',
                text: 'Estamos aplicando los cambios en el registro'
            }
        })
        if (confirm) {
            await serverRequest(endPoint, id, { ...row, status: e.value }, 'POST')
            if (isList) {
                dispatch(handleChange(e.value, 'status', index))
            } else {
                console.log(collection, { name: 'status', value: e.value })
                dispatch(editCollectionRegister(collection, { name: 'status', value: e.value }))
            }
        }
    }

    return <ReactSelect
        styles={{ ...reactSelectStyles }}
        className='w-100'
        name='status'
        isSearchable={false}
        isClearable={false}
        placeholder='Estado'
        value={{ value: status, label: options.find(f => f.value === status)?.label }}
        components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
        options={options}
        onChange={(e) => handleOnChange(e)}
        menuPortalTarget={document.body}
        menuPlacement={'bottom'}
    />
}

export const basicStatus = (status) => <Badge color={`light-${status ? 'success' : 'danger'}`}>{status ? 'Activo' : 'Inactivo'}</Badge>
export const basicDateDMY = (date) => getDateTime(date, '/')
export const actionList = (row, abilityName, path, del = true, inc = false, customEnd = null, totalPath = true) => <div className='d-flex'>{basicActions(row, abilityName, path, del, inc, customEnd, totalPath)}</div>
export const modeIcon = (row, l = 'name', a, path = a, t = true) => <div className="d-flex"><label>{row.mode ? (<FontAwesomeIcon icon={faBan} color="red" />) : (<FontAwesomeIcon icon={faCheck} color="green" />)} {linkAction(row, a, path, l, t)}</label></div>
export const nameList = (d) => (Array.isArray(d) ? d.map(o => <li> - {o.name}</li>) : null)
export const nameLink = (row, abilityName, path, l = 'name', t = true) => <div className='d-flex'><label>{linkAction(row, abilityName, path, l, t)}</label></div>